<template>
  <at-modal
    v-model="showMe"
    :showFooter="false"
    title="Обратная связь"
    :styles="{ maxWidth: '100vw' }"
  >
    <div class="maindiv">
      <div class="searchitem__body">
        <p style="text-align: center; font-size: 110%">
          Для отправки сообщения разработчикам Словаря заполните, пожалуйста,
          эту форму.
        </p>
        <label for="username">Ваше имя</label>
        <at-input
          v-model="username"
          name="username"
          size="large"
          placeholder="Введите Ваше имя"
        ></at-input>
        <label for="email">Ваш email для ответа</label>
        <at-input
          v-model="email"
          name="email"
          type="email"
          size="large"
          placeholder="Введите Ваш email"
        ></at-input>
        <label for="message">Ваше сообщение</label>
        <at-textarea
          v-model="message"
          name="message"
          min-rows="2"
          max-rows="8"
          placeholder="Введите Ваше сообщение"
        ></at-textarea>
        <at-button
          type="primary"
          size="large"
          style="margin-top: 16px; float: right"
          @click="sendmail"
          >Отправить</at-button
        >
      </div>
    </div>
  </at-modal>
</template>

<script>
function isEmail(str) {
  //eslint-disable-next-line
  let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return emailRegex.test(str);
}

export default {
  data: () => ({
    showMe: true,
    username: "",
    email: "",
    message: "",
  }),
  watch: {
    showMe() {
      if (!this.showMe) {
        this.$router.push({ path: "/" });
        this.$recaptchaInstance.hideBadge();
      }
    },
  },
  methods: {
    async sendmail() {
      if (this.username == "")
        return this.$Notify.error({
          message: "Введите Ваше имя, пожалуйста.",
          duration: 2000,
        });
      if (this.email == "" || !isEmail(this.email))
        return this.$Notify.error({
          message: "Введите корректный Email, пожалуйста.",
          duration: 2000,
        });
      if (this.message == "" || this.message.length < 10)
        return this.$Notify.error({
          message: "Введите в сообщении более 10 символов, пожалуйста.",
          duration: 2000,
        });
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");

      this.$Loading.start();
      this.$store
        .dispatch("sendmail", {
          username: this.username,
          email: this.email,
          message: this.message,
          token,
        })
        .then((resp) => {
          if (resp.data.status == "OK") {
            console.log(resp.data);
            this.$Loading.finish();
            this.$Notify.success({
              message: "Сообщение отправлено!",
              duration: 2000,
            });
          } else {
            this.$Loading.error();
            this.$Notify.error({
              message:
                "Возникла ошибка. Попробуйте отправить сообщение позднее.",
              duration: 2000,
            });
          }
        })
        .catch(() => {
          this.$Loading.error();
          this.$Notify.error({
            message: "Возникла ошибка. Проверьте сеть.",
            duration: 2000,
          });
        });
    },
  },
  mounted() {
    this.$recaptchaInstance.showBadge();
  },
  unmounted() {
    this.$recaptchaInstance.hideBadge();
  },
};
</script>

<style scoped>
p {
  font-family: "Century Gothic", sans-serif;
  text-align: justify;
  font-size: 120% !important;
  margin: 6px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.maindiv {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
}

.searchitem__body {
  margin-bottom: 0;
  overflow-y: auto;
}

@media (max-width: 576px) {
  .maindiv {
    height: calc(100vh - 130px);
    min-height: calc(100vh - 130px);
  }
}
</style>